import { SET_ORDERS, SET_IS_COMPLETE, SET_FETCHING_MORE, SET_NEXT_INDEX, SET_THIS_ORDER_DETAIL, } from "../actions/types";
const initialState = {
    orders: [],
    isComplete: false,
    fetchingMore: false,
    nextIndex: 0,
    thisOrderDetail: {
        Items: [],
        ORDER_ID: "0",
        PAYMENT_METHOD: [],
        SHIPPING_ADDRESS: [],
        TOTAL_PRICE: "",
        orderDate: "",
        orderStatus: "",
        pricing_summary: [],
        tracking_url: "",
        DISCOUNT: "",
        FLAT_ITEMS: [],
        ORDER_NUM: 0,
        NEEDS_TO_SET: false,
        PASSWORD_SET: "",
        SHIPPING_COST: "",
        SHIPPING_SPEED: "",
        TAX: "",
        DELIVERYDATE: "",
    },
};
export default function orderHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ORDERS: {
            return {
                ...state,
                orders: action.payload,
            };
        }
        case SET_IS_COMPLETE: {
            return {
                ...state,
                isComplete: action.payload,
            };
        }
        case SET_FETCHING_MORE: {
            return {
                ...state,
                fetchingMore: action.payload,
            };
        }
        case SET_NEXT_INDEX: {
            return {
                ...state,
                nextIndex: action.payload,
            };
        }
        case SET_THIS_ORDER_DETAIL: {
            return {
                ...state,
                thisOrderDetail: action.payload,
            };
        }
        default:
            return state;
    }
}
